var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c("div", { staticStyle: { height: "100%" } }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-wrap": "nowrap",
              height: "100%"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "20%", "background-color": "#ffffff" }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      position: "absolute",
                      top: "6px",
                      padding: "2px",
                      "background-color": "#169bd5",
                      cursor: "pointer",
                      color: "#169bd5"
                    }
                  },
                  [_vm._v(_vm._s("."))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "10px",
                      "padding-bottom": "5px"
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("CargoMsg.Cargo_ConfigExecuteCommands"))
                    )
                  ]
                ),
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "grid-options": _vm.gridOptions
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "20%", "background-color": "#ffffff" }
              },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%", "padding-top": "20px" },
                    attrs: { "label-position": "right", "label-width": "70px" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("CargoMsg.Cargo_SelectCommand") }
                      },
                      [
                        _vm.form.taskScenario ===
                        _vm.SystemConstants.TASK_SCENARIO_6.code
                          ? _c("tenant-instruction-batch-lob-dialog", {
                              key: _vm.command.serialNumber,
                              staticStyle: { width: "250px" },
                              attrs: {
                                "input-width": "100%",
                                lobs: _vm.instructionsLobs,
                                "apply-auto-execute": true,
                                value: _vm.command.commandName,
                                "tag-field": "platformInstructionCode",
                                "tenant-instructions": _vm.tenantInstructions
                              },
                              on: {
                                change: function(p) {
                                  return _vm.tenantInstructionChange(
                                    p,
                                    _vm.command
                                  )
                                }
                              }
                            })
                          : _c("tenant-instruction-dialog", {
                              key: _vm.command.serialNumber,
                              staticStyle: { width: "250px" },
                              attrs: {
                                "input-width": "100%",
                                lob: "FS",
                                "apply-auto-execute": true,
                                value: _vm.command.commandName,
                                "tag-field": "platformInstructionCode",
                                "tenant-instructions": _vm.tenantInstructions
                              },
                              on: {
                                change: function(p) {
                                  return _vm.tenantInstructionChange(
                                    p,
                                    _vm.command
                                  )
                                }
                              }
                            })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "input-from",
                        staticStyle: { height: "100%" },
                        attrs: { label: " " }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "250px" },
                          attrs: {
                            "filter-chars": false,
                            type: "textarea",
                            rows: 20,
                            clearable: ""
                          },
                          model: {
                            value: _vm.command.dataScript,
                            callback: function($$v) {
                              _vm.$set(_vm.command, "dataScript", $$v)
                            },
                            expression: "command.dataScript"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", {
              staticClass: "section",
              staticStyle: {
                width: "60%",
                height: "99%",
                "background-color": "#ffffff"
              }
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }